import { getJson } from './http';
import type { EmployeesOverview } from '../../views/CompanyDashboard/types';

export async function fetchEmployeesOverview(params: { from?: string; to?: string }, signal?: AbortSignal): Promise<EmployeesOverview> {
  return await getJson<EmployeesOverview>('/employees/overview', params, signal);
}
